import './styles/Miscellaneous.scss';
import { System_DeviceOrientationMap } from '../assets/keyMap';
import { AppContext, ExAppContext } from '../Context';
import { Miscellaneous_PageMap } from '../assets/keyMap';
import { useContext, useState, useEffect } from 'react';
import { useLocation, useHistory } from 'react-router';
import axios from 'axios';
import { Browser } from '@capacitor/browser';

//controllers
import InfinityEncryptor from '../plugins/InfinityEncryptor';

//mui
import SmartphoneIcon from '@mui/icons-material/Smartphone';
import AppShortcutIcon from '@mui/icons-material/AppShortcut';

const nonstate = {
    fetchUrl: 'https://www.ppkm.org.my/mobile_backend/assets/miscellaneous/index.php',
    membership_manual_url: 'https://www.ppkm.org.my/mobile_backend/assets/miscellaneous/PPKM_SUPERAPP_MEMBERSHIP.pdf',
    secretariat_manual_url: 'https://www.ppkm.org.my/mobile_backend/assets/miscellaneous/PPKM_SUPERAPP_SECRETARIAT.pdf',
}

interface Props {

}

const Miscellaneous: React.FC<Props> = ({ }) => {
    //contexts
    const appContext = useContext(AppContext);
    const exAppContext = useContext(ExAppContext);
    //states
    const [page, SetPage] = useState<number>(0);
    const [contentImgUrl, SetContentImgUrl] = useState<string>('');
    //react router objs
    const location = useLocation();
    const history = useHistory();
    //controllers
    const iencryptor = new InfinityEncryptor('22499', 'MYDIH');

    //watchers
    useEffect(() => {
        const pathnameArr = location.pathname.split('/');

        if (pathnameArr[pathnameArr.length - 1] != 'Miscellaneous') {
            SetPage(parseInt(pathnameArr[pathnameArr.length - 1]));
        }
    }, [location.pathname]);

    //watch for page change
    useEffect(() => {
        let formData = new FormData();
        switch (page) {
            default:
            case Miscellaneous_PageMap.ABOUT_APP:
                appContext.SetHeaderTitle('About App');
                //fetch contentImgUrl
                formData.append('fetchAboutApp', iencryptor.Encrypt('true'));
                break;
            case Miscellaneous_PageMap.PRIVACY_POLICY:
                appContext.SetHeaderTitle('Privacy Policy');
                //fetch contentImgUrl
                formData.append('fetchPrivacyPolicy', iencryptor.Encrypt('true'));
                break;
            case Miscellaneous_PageMap.TERMS_AND_CONDITIONS:
                appContext.SetHeaderTitle('Terms And Conditions');
                //fetch contentImgUrl
                formData.append('fetchTermsAndConditions', iencryptor.Encrypt('true'));
                break;
            case Miscellaneous_PageMap.CONTACT_US:
                appContext.SetHeaderTitle('Contact Us');
                break;
        }
        //set header back action
        appContext.SetHeaderBackAction(() => () => { history.push('/Profile'); });

        //handle fetch contentImg action
        formData.append('s3cr3t', iencryptor.Encrypt(appContext.secret));
        axios.post(nonstate.fetchUrl, formData, { withCredentials: false }).then((res: any) => {
            const resData = iencryptor.Decrypt(res.data);
            if (!JSON.stringify(resData).includes('_false')) {
                SetContentImgUrl(resData);
            }
        }).catch((err: string) => {
            console.log('fetchAboutAppErr: ' + err);
        });
    }, [page]);

    //ui functions
    const OnCoordinatesClicked = async () => {
        await Browser.open({ url: 'https://www.google.com/maps/dir/Persatuan+Pengurusan+Kompleks+Malaysia/Persatuan+Pengurusan+Kompleks+Malaysia,+A608+6th+Floor+Lobby+2+Block+A,+1,+Jalan+SS+20%2F27,+Damansara+Intan,+47400+Petaling+Jaya,+Selangor/@3.1261149,101.6274697,16.21z/data=!4m13!4m12!1m5!1m1!1s0x0:0x5be6033822956e64!2m2!1d101.6293065!2d3.1302639!1m5!1m1!1s0x31cc4947ad861301:0x5be6033822956e64!2m2!1d101.6293065!2d3.1302639' });
    }

    //render functions
    const RenderPage = () => {
        switch (page) {
            default:
                return (
                    <img className='content-img' src={contentImgUrl} />
                );
            case Miscellaneous_PageMap.CONTACT_US:
                return (RenderContactUsPage());
            case Miscellaneous_PageMap.USER_MANUALS:
                return (RenderUserManualsPage());
        }
    }
    const RenderContactUsPage = () => {
        return (
            <div className='page contact-us'>
                {/* <div className='page-col'>
                    <span className='page-subtitle'>Should you have any enquiry, please do not hesitate to contact Evelyn, Lai Fun or Murali at the PPK Malaysia Secretariat.</span>
                </div> ---deprecated*/}
                <div className='page-col'>
                    <span className='page-title'>Address:</span>
                    <span className='page-title'>Persatuan Pengurusan<br />Kompleks Malaysia (PPKM)<br />Malaysia Shopping Mall Association</span>
                    <span className='page-subtitle'>A608, 6th Floor, Block A (Lobby No. 2),<br />Damansara Intan,<br />47400 Petaling Jaya, Malaysia</span>
                    <div className="page-map">
                        <iframe width="100%" height="100%" loading="lazy" allowFullScreen src="https://www.google.com/maps/embed/v1/place?key=AIzaSyBFw0Qbyq9zTFTd-tUY6dZWTgaQzuU17R8&q=A608%2C%206th%20Floor%2C%20Block%20A%20(Lobby%20No.%202)%2C%20%20Damansara%20Intan%2C%20%2047400%20Petaling%20Jaya%2C%20Malaysia&zoom=10&maptype=roadmap"></iframe>
                    </div>
                    <div className='page-title'>
                        GPS Coordinates:
                        <button className='page-title ex' onClick={() => OnCoordinatesClicked()}>3.130237, 101.629329</button>
                    </div>
                </div>
                <div className='page-col'>
                    <span className='page-title'>Tel:</span>
                    <a className='page-subtitle' href="tel:603-7727 6202">603 – 7727 6202</a>
                    <a className='page-subtitle' href="tel:603-7727 6232">603 – 7727 6232</a>
                </div>
                <div className='page-col'>
                    <span className='page-title' >Email :</span>
                    <a className='page-subtitle' href="mailto:secretariat@ppkm.org.my">secretariat@ppkm.org.my</a>
                </div>
                <div className='page-col'>
                    <span className='page-title'>URL :</span>
                    <a className='page-subtitle' href="http://www.ppkm.org.my/">http://www.ppkm.org.my/</a>
                </div>
            </div>
        );
    }
    const RenderUserManualsPage = () => {
        return (
            <div className='page user-manuals'>
                <button className='page-btn' onClick={() => Browser.open({url: nonstate.membership_manual_url})}>
                    <SmartphoneIcon />
                    Super App Membership Manual
                </button>
                <button className='page-btn' onClick={() => Browser.open({url: nonstate.secretariat_manual_url})}>
                    <AppShortcutIcon />
                    Super App Secretariat Manual
                </button>
            </div>
        );
    }

    //exe functions
    const GetObjectKeyByValue = (subject: any, value: string) => {
        let res = '';
        Object.keys(subject).map((key: string) => {
            if (subject[key] == value)
                res = key;
        });
        return res;
    }

    return (
        <div className={'Miscellaneous ' + (appContext.deviceOrientation == System_DeviceOrientationMap.LANDSCAPE ? 'landscape' : 'portrait')}>
            {
                RenderPage()
            }
        </div>
    )
}
export default Miscellaneous;